import Button from 'components/UI/V3/Button/Button';
import { FunctionComponent } from 'react';
import styles from './RecipientsWillSeeCard.module.scss';

interface RecipientsWillSeeCardProps {
    /** Effective From email (verified custom sender, or Cuddles default). */
    senderEmail: string;
    /** Marketplace business name — surfaces inside the quoted display name
     *  of the preview (`"Pet Shop" <marketing@petshop.com>`). Falls back to
     *  the bare address when empty. */
    businessName: string;
    /** When provided, the card renders an Edit Email button on the right.
     *  Used in the verified state; omitted in the unconfigured state since
     *  there's nothing to edit. */
    onEditEmail?: () => void;
}

/**
 * Beige preview card showing the From header recipients will see. Shared
 * between UnconfiguredState (renders the Cuddles default with no Edit
 * button) and VerifiedState (renders the marketplace's verified sender +
 * Edit button on the right).
 */
const RecipientsWillSeeCard: FunctionComponent<RecipientsWillSeeCardProps> = ({
    senderEmail,
    businessName,
    onEditEmail
}) => {
    const preview = businessName ? `"${businessName}" <${senderEmail}>` : senderEmail;

    return (
        <div className={styles.card}>
            <div className={styles.textBlock}>
                <p className={styles.label}>Recipients Will See:</p>
                <p className={styles.preview}>{preview}</p>
            </div>
            {onEditEmail && (
                <Button
                    size="medium"
                    label="Edit Email"
                    variant="black"
                    onClick={onEditEmail}
                />
            )}
        </div>
    );
};

export default RecipientsWillSeeCard;
